import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrganizationState } from './organization.state';

export const selectOrganizationState = createFeatureSelector<OrganizationState>('organization');

export const selectOrganizationDepots = createSelector(selectOrganizationState, (state: OrganizationState) => state.depots);

export const selectOrganizationExternalCredentials = createSelector(selectOrganizationState, (state: OrganizationState) => state.externalCredentials);
